import React, { useEffect, useState } from "react";
import { withRouter } from "../../helper/withRouter";
import { connect } from "react-redux";
import { SUPPLY_CHAIN_MANAGER_LINK } from "../../constants/supplyChainManager/link";
import AdminSection from "./parts/AdminSection";
import { isEmpty } from "lodash";
import { RK_DIVISION_KEY, USER_BUSINESS_UNIT } from "../../constants/userInfo/userBusinessUnit";

// Import our menu components
import MechanicalMenu from "./menus/MechanicalMenu";
import EnergyMenu from "./menus/EnergyMenu";
import ElectricalMenu from "./menus/ElectricalMenu";
import SteelMenu from "./menus/SteelMenu";
import OtherMenu from "./menus/OtherMenu";

const getFeatures = process.env.REACT_APP_FEATURES;
const arrayFeatures = getFeatures?.split(", ");

/**
 * Unified Sidebar component that contains shared functionality
 * and delegates division-specific menu items to specialized components
 */
function Sidebar({ userData, location, navigate }) {
    const { mechanical, energy, electrical, steel } = USER_BUSINESS_UNIT;
    const rkDivision = localStorage.getItem(RK_DIVISION_KEY) ?? USER_BUSINESS_UNIT.mechanical;


    const [state, setState] = useState({
        isJobLoading: false,
        isCheckingUnitedRental: false,
    });



    const jobTitle = userData?.user?.job_title?.toLowerCase();

    /**
     * Check if a path is active
     */
    const isPathActive = (path) => {
        return location.pathname.startsWith(path);
    };

    /**
     * Menu state toggle logic (shared across all sidebars)
     */
    const toggleMenuState = (menuState) => {
        if (state[menuState]) {
            setState((prevState) => ({ ...prevState, [menuState]: false }));
        } else if (Object.keys(state).length === 0) {
            setState((prevState) => ({ ...prevState, [menuState]: true }));
        } else {
            const allState = state;

            // Checking for the from admin is have sub menu
            if (menuState.includes("adminSubMenu")) {
                delete allState["admin"];
                setState((prevState) => ({ ...prevState, admin: true }));
            }
            
            // Checking for the menu from vdc is have sub menu
            if (
                menuState.includes("batchPlan") ||
                menuState.includes("task_scheduler") ||
                menuState.includes("spooling")
            ) {
                delete allState["vdc"];
                setState((prevState) => ({ ...prevState, vdc: true }));
            }
            
            // Checking for the menu from Supply Chain Catalog is have sub menu
            if (menuState?.includes("requisitionList")) {
                delete allState["supplyChainCatalog"];
                setState((prevState) => ({ ...prevState, supplyChainCatalog: true }));
            }
            
            // Checking for the menu from supply chain manager is have sub menu
            if (menuState.includes("adminSubMenuMasterMaterialRecords") || menuState.includes("adminSubMenuNewRecord")) {
                delete allState["adminSubMenuSupplyChain"];
                delete allState["adminSubMenuNewRecord"];
                setState((prevState) => ({
                    ...prevState,
                    adminSubMenuSupplyChain: true,
                }));
            }

            // Checking for the menu from new records, existing records and map records is have sub menu
            if (
                menuState.includes("adminSubMenuMasterMaterialNewRecords") ||
                menuState.includes("adminSubMenuMasterMaterialExistingRecords") ||
                menuState.includes("adminSubMenuMasterMaterialMapRecords") 
            ) {
                delete allState["adminSubMenuMasterMaterialRecords"];
                delete allState["adminSubMenuSupplyChain"];
                setState((prevState) => ({
                    ...prevState,
                    adminSubMenuMasterMaterialRecords: true,
                    adminSubMenuSupplyChain: true,
                }));
            }

            Object.keys(allState).forEach((i) => {
                if (!i.includes("is")) {
                    setState((prevState) => ({ ...prevState, [i]: false }));
                }
            });

            setState((prevState) => ({ ...prevState, [menuState]: true }));
        }
    };

    /**
     * Job search functionality (shared across all sidebars)
     */
    // const handleChangeJob = async (selected) => {
    //     if (selected) {
    //         const toSummary = {
    //             jobName: selected.label,
    //             jobId: selected.value,
    //         };
    //         const query = {
    //             page: 1,
    //             is_admin: "False",
    //             job_number: selected.value,
    //             is_check: true,
    //         };
    //         setState((prevState) => ({
    //             ...prevState,
    //             isCheckingUnitedRental: true,
    //         }));
    //         await getUnitedTransactionRental(qs.stringify(sanitizeObj(query)), {
    //             parseBooleans: true,
    //         });
    //         setState((prevState) => ({
    //             ...prevState,
    //             isCheckingUnitedRental: false,
    //         }));
    //         const toSummaryURL = new URLSearchParams(toSummary).toString();
    //         window.location = `/field-summary?${toSummaryURL}`;
    //     }
    // };

    /**
     * Fetch job options for AsyncSelect (shared across all sidebars)
     */
    // const _fetchJobOptions = async (jobId) => {
    //     try {
    //         const res = await getJobListVista(jobId);
    //         const jobOptions = res?.data?.map((val) => ({
    //             label: `${val.vista_id} ${val.description}`,
    //             value: val.vista_id,
    //         }));

    //         return jobOptions;
    //     } catch (error) {
    //         console.error(error);
    //         return [];
    //     }
    // };

    /**
     * Handle hover effect and initial menu state (shared across all sidebars)
     */
    useEffect(() => {
        const body = document.querySelector("body");
        document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
            el.addEventListener("mouseover", function () {
                if (body.classList.contains("sidebar-icon-only")) {
                    el.classList.add("hover-open");
                }
            });
            el.addEventListener("mouseout", function () {
                if (body.classList.contains("sidebar-icon-only")) {
                    el.classList.remove("hover-open");
                }
            });
        });

        // This is for auto collapse menu when accessing path
        const menuStates = [
            { path: "/admin", state: "admin" },
            { path: "/admin/catalog", state: "adminSubMenuMasterMaterialRecords" },
            { path: "/admin/mastering", state: "adminSubMenuMasterMaterialRecords" },
            { path: "/admin/material-import-log", state: "adminSubMenuSupplyChain" },
            { path: "/batch-plan", state: "batchPlan" },
            { path: "/batch-tracker", state: "appsMenuOpen" },
            { path: "/catalog", state: "catalogApp" },
            { path: "/receiving", state: "receiving" },
            { path: "/receiving/backorder-report", state: "report" },
            { path: "/receiving/csv-export", state: "report" },
            { path: "/spooling", state: "spooling" },
            { path: "/supply-chain-catalog", state: "supplyChainCatalog" },
            { path: "/task-scheduler", state: "task_scheduler" },
            { path: SUPPLY_CHAIN_MANAGER_LINK, state: "adminSubMenuMasterMaterialRecords" },
        ];
        
        menuStates.forEach(({ path, state }) => {
            if (isPathActive(path)) {
                toggleMenuState(state);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Job search common component
     */
    // const JobSearchComponent = () => (
    //     <li className={isPathActive("/dashboard") ? "nav-item active" : "nav-item"}>
    //         <Form noValidate className="pt-3">
    //             <AsyncSelect
    //                 isDisabled={isCheckingUnitedRental}
    //                 placeholder="Enter Job #"
    //                 loadOptions={debounce(_fetchJobOptions, 1000, { leading: true })}
    //                 onChange={handleChangeJob}
    //                 classNamePrefix="job-select"
    //                 components={{
    //                     DropdownIndicator: () => null,
    //                     IndicatorSeparator: () => null,
    //                 }}
    //             />
    //             {isCheckingUnitedRental && (
    //                 <p className="text-white text-center mt-2">Please Wait...</p>
    //             )}
    //         </Form>
    //     </li>
    // );

    /**
     * Common props for all menu components
     */
    const menuProps = {
        state,
        isPathActive,
        toggleMenuState,
        arrayFeatures,
        navigate,
        userData,
        jobTitle
    };

    // Hide sidebar when on login screen
    if (isEmpty(userData) || location.pathname?.includes('/login')) {
        return <></>;
    }

    return (
        <nav className="sidebar sidebar-fixed sidebar-offcanvas" id="sidebar">
            <ul className="nav">
                {/* <JobSearchComponent /> */}
                {/* Conditionally render the appropriate menu based on the division */}
                {rkDivision?.includes(electrical) && <ElectricalMenu {...menuProps} />}
                {rkDivision?.includes(energy) && <EnergyMenu {...menuProps} />}
                {rkDivision?.includes(mechanical) && <MechanicalMenu {...menuProps} />}
                {rkDivision?.includes(steel) && <SteelMenu {...menuProps} />}
                {!rkDivision?.includes(electrical) && 
                 !rkDivision?.includes(energy) && 
                 !rkDivision?.includes(mechanical) && 
                 !rkDivision?.includes(steel) && <OtherMenu {...menuProps} />}

                {/* Admin section is common to all divisions */}
                {userData?.user?.is_superuser && (
                    <AdminSection
                        isPathActive={isPathActive}
                        toggleMenuState={toggleMenuState}
                        stateMenu={state}
                        userData={userData}
                    />
                )}
            </ul>
        </nav>
    );
}

const mapStateToProps = (state) => {
    return {
        userData: state.userReducer,
    };
};

export default connect(mapStateToProps)(withRouter(Sidebar));